import { InputProps, Text } from '@telegram-apps/telegram-ui';
import { forwardRef } from 'react';
import styled from 'styled-components';

const typographyStyle: any = {
    display: 'block',
    width: '100%',
    margin: '0',
    border: '0',
    outline: '0',
    padding: '0',
    resize: 'none',
    background: 'transparent',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    color: 'var(--tgui--text_color)',
    '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none'
    },
    '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none'
    },
    '&::placeholder': {
        color: 'var(--tgui--secondary_hint_color)'
    }
}

const StyledTextTypography = styled(Text)(typographyStyle);

const CustomFormInput = styled.div({
    position: 'relative',
    background: 'transparent',
    minHeight: '48px'
});

type CustomInputProps = InputProps & { wrapperStyle?: React.CSSProperties };

export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(({
    type = 'text',
    wrapperStyle,
    header,
    before,
    after,
    status,
    className,
    disabled,
    ...restProps
  }, ref) => {
    return (
        <CustomFormInput style={wrapperStyle}>
            <StyledTextTypography
                ref={ref}
                Component="input"
                type={type}
                disabled={disabled}
                {...restProps}
            />
        </CustomFormInput>
    );
});
